import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { cilSearch } from '@coreui/icons';
import { ApiService } from 'src/app/service/api/api.service';

@Component({
  selector: 'app-sidebar-sceau',
  templateUrl: './sidebar-sceau.component.html',
  styleUrls: ['./sidebar-sceau.component.scss']
})
export class SidebarSceauComponent implements OnInit, OnChanges {
  @Input() navItems: any[] = [];

  icons = { cilSearch };

  search = '';
  filtered_nav_items: any[] = [];

  constructor(public api: ApiService) { }

  ngOnInit(): void {
    this.apply_filter();
  }

  ngOnChanges(): void {
    this.apply_filter();
  }

  apply_filter() {
    const term = this.normalize(this.search);
    this.filtered_nav_items = !term
      ? this.navItems
      : (this.navItems || []).filter(item => this.normalize(item.name || '').includes(term));
  }

  private normalize(s: string): string {
    return (s || '').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
  }

  get nom_complet(): string {
    const user = this.api.infos?.agent;
    return `${user?.prenom || ''} ${user?.nom || ''}`.trim() || 'Agent';
  }

  get role_label(): string {
    return this.api.infos?.current_mairie?.privilege
      || this.api.infos?.current_mairie?.categorie
      || 'Agent';
  }

  get contexte_label(): string {
    return this.api.infos?.current_mairie?.nom || '';
  }

  get initiales(): string {
    return this.nom_complet
      .split(' ')
      .filter(Boolean)
      .map(w => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase() || '?';
  }
}
